import React, { ErrorInfo } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';

interface IErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, IErrorBoundaryState> {
  state: IErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError(): IErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled application error:', error, info);
  }

  private handleDashboard = () => {
    window.location.assign('/');
  };

  private handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Box
        minHeight={'100vh'}
        display={'flex'}
        alignItems={'center'}
        justifyContent={'center'}
        bgcolor={'#f5f6f8'}
        p={2}
      >
        <Paper elevation={2} sx={{ width: '100%', maxWidth: 520, p: 4 }}>
          <Typography variant={'h5'} mb={1}>
            This page could not be displayed
          </Typography>
          <Typography color={'text.secondary'} mb={3}>
            An unexpected error occurred. Reload the page or return to the dashboard.
          </Typography>
          <Box display={'flex'} gap={1} flexWrap={'wrap'}>
            <Button variant={'contained'} startIcon={<RefreshOutlinedIcon />} onClick={this.handleReload}>
              Reload
            </Button>
            <Button variant={'outlined'} startIcon={<HomeOutlinedIcon />} onClick={this.handleDashboard}>
              Dashboard
            </Button>
          </Box>
        </Paper>
      </Box>
    );
  }
}
